function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_100",
  "data-name": "Group 100"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_99",
  "data-name": "Group 99"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_333",
  "data-name": "Path 333",
  d: "M69.3,126.654H-50.609a2.251,2.251,0,0,1-2.2-2.2c-.018-1.229-.012-2.254-.006-3.278l.006-115.2a2.26,2.26,0,0,1,2.223-2.2h0a2.238,2.238,0,0,1,2.162,2.2c.018,1.232.012,2.257.009,3.281l-.009,112.988,2.871.021H74.368a2.232,2.232,0,0,1,2.2,2.22,1.963,1.963,0,0,1-.578,1.446,2.293,2.293,0,0,1-1.618.722l-1.832.015Z",
  transform: "translate(52.817 -3.78)",
  fill: "#141414"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_102",
  "data-name": "Group 102",
  transform: "translate(12.598 19.026)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_334",
  "data-name": "Path 334",
  d: "M-46.5,74.686a2.335,2.335,0,0,1-1.1-.3,2.317,2.317,0,0,1-1.04-1.507,1.756,1.756,0,0,1,.229-1.434l25.141-33.66a2.4,2.4,0,0,1,1.908-1.1,2.628,2.628,0,0,1,1.624.648L6.117,58.113l2.862-3.932,30.642-43.06A2.564,2.564,0,0,1,41.639,10a2.022,2.022,0,0,1,1.452.633L64.013,31.682a2.263,2.263,0,0,1-.018,3.128,2,2,0,0,1-1.492.605,2.257,2.257,0,0,1-1.593-.627L41.847,15.61,39.159,19.3,8.517,62.363A2.294,2.294,0,0,1,6.64,63.455,2.671,2.671,0,0,1,4.992,62.8L-20.948,41.962l-23.6,31.6A2.489,2.489,0,0,1-46.5,74.686Z",
  transform: "translate(48.697 -10.002)",
  fill: "#3d99b8"
})));

var SvgUsageManager = function SvgUsageManager(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_103",
    "data-name": "Group 103",
    width: 129.383,
    height: 122.889,
    viewBox: "0 0 129.383 122.889",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsageManager, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UsageManager.d718eb39.svg";
export { ForwardRef as ReactComponent };